import { Component } from 'react';

function withDropdownStateManagement(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      this.state = { allowDropdown: false };
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          allowDropdown={this.state.allowDropdown}
          hideResults={this.hideResults}
          showResults={this.showResults}
        />
      );
    }

    showResults = () => {
      this.setState({ allowDropdown: true });
    };

    hideResults = () => {
      this.setState({ allowDropdown: false });
    };
  };
}

export default withDropdownStateManagement;
